import React, { Component } from 'react';
import { formatPricing } from 'src/helpers';

class AddToCardPreview extends Component<ComposedProps, State> {
  render() {
    const { numberOfRecommendProduct: numberOfProduct, selectedProducts, tenantApp } = this.props;
    let total = 0;
    const products = Object.values(selectedProducts);
    for (let i = 0; i < numberOfProduct; i++) {
      total += products[i] && products[i].selected && products[i].price ? +products[i].price : 0;
    }
    return (
      <React.Fragment>
        <div className="cart">
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}>
              <div className="total">
                Total price: <span>{formatPricing(total, tenantApp?.externalInfo?.money_in_emails_format)}</span>
              </div>
              <button className="add-to-cart">Add to Cart</button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default AddToCardPreview;
